import { useDesignMaxTheme } from "@/packages";
import { LOCAL_STORAGE, usePensionNameValue } from "@/shared/client";
import { FONT } from "@/styles";
import { Box, chakra, Flex, Text } from "@chakra-ui/react";
import { motion } from "framer-motion";
import { type RoomListType } from "../../../otherRoomPreview/otherRoomPreview.type";

export const RoomDetail = ({ rooms, currentIdx }: { currentIdx: number; rooms: RoomListType[] }) => {
    const { MEDIAS } = useDesignMaxTheme();
    const pensionName = usePensionNameValue();
    const pensionNameEng = LOCAL_STORAGE.get({ key: "pensionNameEng" });
    const { isMobile } = MEDIAS();

    return (
        <Flex flexDir="column" gap={isMobile ? "16px" : "32px"}>
            <Box
                sx={{
                    "& p": {
                        color: "#664628",
                    },
                }}
            >
                <Text mb={isMobile ? "4px" : "8px"} {...FONT("notoSerif", isMobile ? 14 : 24, 400, 1.4)}>
                    {pensionName}
                </Text>
                <Text {...FONT("notoSerif", isMobile ? 20 : 40, 600, 1.4)}>{pensionNameEng} ROOMS</Text>
            </Box>
            <Box position="relative" w={isMobile ? "100%" : "513px"} minHeight={isMobile ? "266PX" : "383px"}>
                {rooms.map((t, index) => (
                    <MotionDetailBox
                        display="flex"
                        position="absolute"
                        key={t.room_idx}
                        flexDir="column"
                        rowGap={isMobile ? "16PX" : "24PX"}
                        initial={{ opacity: index === currentIdx ? 1 : 0 }}
                        animate={{
                            opacity: index === currentIdx ? 1 : 0,
                            transition: { duration: 0.7, ease: "easeIn" },
                        }}
                    >
                        <Box>
                            <Text mb={isMobile ? "8px" : "16px"} {...FONT("notoSerif", isMobile ? 16 : 32, 400, 1.4)}>
                                {t.room_name}
                            </Text>
                            <Text color="#6b6b6b" {...FONT("pretendard", isMobile ? 14 : 16, 300, 1.4)}>
                                객실설명
                            </Text>
                            <Text color="#6b6b6b" {...FONT("pretendard", isMobile ? 14 : 16, 300, 1.4)}>
                                {t.room_intro}
                            </Text>
                        </Box>
                        <Box>
                            <Text color="#664628" {...FONT("notoSerif", 14, 400, 1.4)}>
                                Room Type
                            </Text>
                            <Text color="#6b6b6b" {...FONT("pretendard", isMobile ? 14 : 16, 300, 1.4)}>
                                {" "}
                                {t.room_type}
                            </Text>
                        </Box>
                        <Box>
                            <Text color="#664628" {...FONT("notoSerif", 14, 400, 1.4)}>
                                Number of People
                            </Text>
                            <Flex gap={isMobile ? "8px" : "16px"}>
                                <Text
                                    color="#6b6b6b"
                                    {...FONT("pretendard", isMobile ? 14 : 16, 300, 1.4)}
                                >{`기준 ${t.people.min}인 ~ 최대 ${t.people.max}인`}</Text>
                            </Flex>
                        </Box>
                    </MotionDetailBox>
                ))}
            </Box>
        </Flex>
    );
};

const MotionDetailBox = chakra(motion.div);
